import { defineAsyncComponent } from 'vue'
export default {
  checkout: defineAsyncComponent(() => import("/Users/mile/Projekti/bigbang.si/layouts/checkout.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/Users/mile/Projekti/bigbang.si/layouts/default.vue").then(m => m.default || m)),
  spinner: defineAsyncComponent(() => import("/Users/mile/Projekti/bigbang.si/layouts/spinner.vue").then(m => m.default || m)),
  blank: defineAsyncComponent(() => import("/Users/mile/Projekti/nuxt-base/layouts/blank.vue").then(m => m.default || m)),
  bot: defineAsyncComponent(() => import("/Users/mile/Projekti/nuxt-base/layouts/bot.vue").then(m => m.default || m))
}